import React from 'react';
import type { WCardSuiteSummaryView } from '@zola/svc-web-api-ts-client';
import Title from '@zola/zola-ui/src/components/PreAuthV3/HighlightTitle';
import { getCardDefaultColor, Collection } from './utils';

import { Item, StyledButton, SuiteTypeTile, StyledSuiteTile } from './SuiteList.style';

interface SuiteTypeProps {
  title: JSX.Element;
  cta: string;
  link: string;
}

const SuiteType: React.FC<SuiteTypeProps> = ({ title, cta, link }) => (
  <Item>
    <SuiteTypeTile>
      <Title isH1={false}>{title}</Title>
      <StyledButton variant="secondary" component="a" href={link}>
        {cta}
      </StyledButton>
    </SuiteTypeTile>
  </Item>
);

interface SuiteListProps extends SuiteTypeProps {
  suites: WCardSuiteSummaryView[];
  collections: Collection[];
  position: 'head' | 'tail';
}

export const SuiteList: React.FC<SuiteListProps> = ({ suites, collections, position, ...rest }) => (
  <>
    {position === 'head' ? <SuiteType {...rest} /> : null}

    {collections.map(collection => {
      const suite = suites.find(_ => _.uuid === collection.uuid);

      if (!suite) return <Item key={collection.uuid} />;

      return (
        <Item key={collection.uuid}>
          <StyledSuiteTile
            defaultColor={getCardDefaultColor(collections)(suite)}
            colorPickerOptions={{ swatchWidth: 16 }}
            suite={suite}
            hideColorPickerInMobile
          />
        </Item>
      );
    })}

    {position === 'tail' ? <SuiteType {...rest} /> : null}
  </>
);
